import React, { ReactNode } from 'react';
import clsx from 'clsx';

import { ChartOfAccountsAccount } from '@futrli-sdk/predict';

import { CashFlowImpact } from '../cashflow-impact/cash-flow-impact';
import { MultiPaymentTreatment, PaymentTreatment } from '../../types';
import styles from './prediction-form.scss';

interface PredictionFormProps {
  accountsData?: ChartOfAccountsAccount[];
  children?: ReactNode;
  formError?: boolean;
  onMultiPaymentDataAddNew: () => void;
  onMultiPaymentDataChange: (index: number, data: MultiPaymentTreatment) => void;
  onNonCashAccountIndexChange: (value: ChartOfAccountsAccount | null) => void;
  onPaymentTermsChange: (value: string) => void;
  onPaymentTreatmentChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  multiPaymentData: MultiPaymentTreatment[];
  nonCashAccountIndex: string;
  paymentTerms: string;
  paymentTreatment: PaymentTreatment;
  predictionContentTouched: boolean;
}

export const PredictionForm = ({
  accountsData = [],
  children,
  formError,
  onMultiPaymentDataAddNew,
  onMultiPaymentDataChange,
  onNonCashAccountIndexChange,
  onPaymentTermsChange,
  onPaymentTreatmentChange,
  multiPaymentData,
  nonCashAccountIndex,
  paymentTerms,
  paymentTreatment,
  predictionContentTouched
}: PredictionFormProps) => (
  <div
    className={clsx(styles.predictionBuilderForm, {
      [styles.formulaFormError]: formError
    })}
  >
    <div className="columns">
      <div className="column is-9" style={{ borderRight: '1px solid rgba(148, 158, 177, 0.2)', minHeight: 380 }}>
        {children}
      </div>
      <div className="column is-3">
        <CashFlowImpact
          paymentTreatment={paymentTreatment}
          handlePaymentTreatmentChange={onPaymentTreatmentChange}
          multiPaymentData={multiPaymentData}
          handleChangeMultiPaymentTreatmentData={onMultiPaymentDataChange}
          addNewMultiPaymentTreatment={onMultiPaymentDataAddNew}
          handlePaymentTermsChange={onPaymentTermsChange}
          paymentTerms={paymentTerms}
          accountRows={accountsData.filter(a => a.category !== 'bank_accounts')}
          nonCashAccountIndex={nonCashAccountIndex}
          handleAutocompleteChange={onNonCashAccountIndexChange}
          predictionContentTouched={predictionContentTouched}
        />
      </div>
    </div>
  </div>
);
